import { LeaderboardDataContext } from "contexts/LeaderboardDataContext";
import { useContext } from "react";


// ==============================|| CONFIG - HOOKS  ||============================== //

const useLeaderboardData = () => useContext(LeaderboardDataContext);

export default useLeaderboardData;
